import React from 'react';
import { css } from '@emotion/css';
import { ConversationTrackingTreeContentNode } from '../../../models/analytics/api/ConversationEventTrackingTreeNode';
import { style_border_default } from '../../../constants/stylesValues';
import { color_colors_decline, color_colors_growth, color_colors_royalty, color_defaults_white, color_shades_light, color_variants_decline_light_1, color_variants_royalty_light_10, color_variants_royalty_light_20 } from '../../../constants/colors';
import NodeSocket from './NodeSocket';
const finishIcon = require('../../../content/images/analytics-icons/finish-flag.svg');
interface SessionEndNodeProps {
    active: boolean
    selected: boolean
    percentage: number
    number: number
    onClick: () => void
}
const SessionEndNode = (props: SessionEndNodeProps) => {
    let percentage: string | number = props.percentage * 100;
    percentage = percentage !== Math.round(percentage) ? percentage.toFixed(2) : percentage
    return (
        <div className={`${containerStyle} ${props.active ? 'active' : 'inactive'} ${props.selected ? 'selected' : 'unselected'}`}>
            <div className="percentage-container">
                <p>{percentage}%</p>
            </div>
            <div className="node-card" onClick={props.onClick}>
                <div className="in-socket">
                    <NodeSocket direction="in" active={props.selected} />
                </div>
                <div className="card-body">
                    <p>Session Ends</p>
                    <img src={finishIcon} alt="session ends" />
                </div>
            </div>
            <div className="circle" />
        </div>
    );
}

const containerStyle = css`
    width: 120px;
    margin: 0 12px;
    position: relative;
    .circle {
        width: 8px;
        height: 8px;
        position: absolute;
        border-radius: 50%;
        top: -84px;
        left: 55px;
        background: ${color_variants_royalty_light_10};
        border: 1px solid ${color_variants_royalty_light_20};
        box-sizing: content-box;
    }
    .percentage-container {
        display: flex;
        position: absolute;
        top: -32px;
        right: 0;
        background: ${color_defaults_white};
        z-index: 5;
        padding: 4px;
        border-radius: 3px;
        border: 1px solid ${color_colors_royalty};
        >p {
            margin-right: 0;
            margin-left: auto;
            color: ${color_colors_royalty};
            text-align: right;   
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
        }
    }
    .node-card {
        cursor: pointer;
        width: 120px;
        height: 80px;
        border-radius: 4px;
        border: ${style_border_default};
        background: #E2A6AE;
        padding: 8px 0;
        position: relative;
        .card-body {
            background: white;
            height: 64px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 16px;
            >p {
                text-align: left;
                font-size: 12px;
                line-height: 16px;
            }
        }
        .in-socket {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 120px;
            position: absolute;
            top: -5px;
            z-index: 3;
        }
    }

    &.inactive {
        opacity: 0.4;
    }
    &.selected {
        .circle {
            background :${color_colors_royalty};
            border: 2px solid white;
            z-index: 3;
            left: 54.5px;
            top: -85px;
        }
    }
`;

export default SessionEndNode;